var router = require('../services/router');
var authorization = require('../services/authorization');

var preloader = require('../components/preloader');
var messages = require('../components/messages');

var Order = require('./Order');

var Orders = function () {
    var self = this;

    var orders_number = 5;
    var orders_increment = 5;

    var full_list = [];
    this.list = ko.observableArray([]);
    this.search_query = ko.observable('');

    this.is_see_more_enabled = ko.observable(true);

    this.search = function () {
        if (self.search_query().trim().length == 0) {
            self.list(full_list);
            return;
        }

        var query = self.search_query().trim();

        self.list(full_list.filter(function (item) {
            return item.search(query);
        }));
    };

    this.fill = function (data) {
        self.clean();
        full_list = [];

        if (data.length < orders_number) {
            self.is_see_more_enabled(false);
        }

        if (!data || data.length == 0) return;

        data.forEach(function (item) {
            var quote = new Order(item);
            full_list.push(quote);
        });

        self.list(full_list);
    };

    this.seeMoreOrders = function () {
        orders_number += orders_increment;
        self.refresh();
    };

    this.refresh = function () {
        function callback(status, data) {
            if (!status) return;

            self.fill(data);
        }

        self.api.get(callback);
    };

    this.clean = function () {
        self.list([]);
    };

    this.cleanSearchForm = function () {
        self.search_query('');
    };

    this.init = function (data) {
        self.fill(data);
    };

    this.api = {
        get: function (callback) {
            preloader.show('get-orders');
            $.ajax({
                url: 'rest.php/orders/' + orders_number,
                method: 'GET',
                dataType: 'json'
            }).done(function (resp) {
                if (callback) callback(true, resp.data);
            }).fail(function (jqXHR, textStatus, error) {
                var error = jqXHR.responseJSON.error;

                if (error.code === 401) {
                    router.goTo('login');
                    authorization.setIsAuthorized(false);
                }

                messages.addItem(error.message);

                if (callback) callback(false);
            }).always(function () {
                preloader.hide('get-orders');
            });
        }
    }
};

module.exports = new Orders();


//////////////////
// WEBPACK FOOTER
// ../textbookx/service/bulk_po/scripts/ExistingOrders/orders.js
// module id = 24
// module chunks = 0